import { forwardRef } from 'react';
import { IonIcon } from '@ionic/react';
import { AllieButtonProps } from './Button.types';
import { StyledButton, StyledButtonSpinner } from './Button.styles';
import './Button.css';

export const AllieButton = forwardRef(
  (
    {
      allieType = 'primary',
      corner = 'rounded',
      shadow = false,
      loading = false,
      disabled = false,
      allieSize = 'normal',
      allieColor = 'primary',
      iconPosition = 'right',
      iconOnly = false,
      full = false,
      icon,
      children,
      ...props
    }: AllieButtonProps,
    ref
  ) => {
    const sizeMapping = {
      normal: 'large',
      medium: 'default',
      small: 'small',
      xs: 'xs',
      none: 'none',
    };

    const iconLeftStyle = { display: 'contents', paddingRight: `${iconOnly ? 'auto' : '14px'}` };
    const iconRightStyle = { display: 'contents', paddingLeft: `${iconOnly ? 'auto' : '14px'}` };

    const renderLoading = () => {
      return <StyledButtonSpinner allieSize={allieSize} children={children} />;
      // return (
      // <>
      {
        /* {iconPosition === 'left' && <span style={iconLeftStyle}><AllieSpinner /></span>} */
      }
      {
        /* {children} */
      }
      {
        /* {iconPosition === 'right' && <span style={iconRightStyle}><AllieSpinner /></span>} */
      }
      {
        /* </> */
      }
      // );
    };

    const renderChildren = () => {
      if (loading) return renderLoading();
      return (
        <>
          {icon && iconPosition === 'left' && <IonIcon icon={icon} slot="start" />}
          <span className={`allie-text-button-${allieSize}`}>{children}</span>
          {icon && iconPosition === 'right' && <IonIcon icon={icon} slot="end" />}
        </>
      );
    };

    return (
      <StyledButton
        allieType={allieType}
        corner={corner}
        shadow={shadow}
        loading={loading}
        full={full}
        allieSize={allieSize}
        allieColor={allieColor}
        size={sizeMapping[allieSize] as any}
        disabled={disabled || loading}
        ref={ref}
        {...props}
      >
        {renderChildren()}
      </StyledButton>
    );
  }
);
